<template>
  <ModalComponent
    v-model="modalVisible"
    class="sablier-devant"
  >
    <template #header>
      {{ store.runOptions?.titre }}
    </template>
    <template #content>
      <component
        :is="runOptions?.component"
        :in="runOptions?.modelIn"
        :out="out"
        :outReady="outReady"
        :contextCourant="runOptions?.contextCourant"
        :transitionState="transitionState?.component"
        @query-cancel="onCancel"
        @out-changed="onOutChanged"
      ></component>
    </template>
    <template #actions>
      <div class="flex">
        <BasicButton
          v-if="runOptions?.canGoBack"
          label="Retour"
          :disabled="!runOptions?.canGoBack"
          @click="onGoBack"
          class="flex-1"
        />
        <div class="flex-2"></div>
        <BasicButton
          label="Continuer"
          :disabled="!outReady"
          @click="onContinue"
          class="flex-1"
        />
      </div>
    </template>
  </ModalComponent>
</template>

<script setup lang="ts">
  import { ref, watch } from 'vue'
  import { storeToRefs } from 'pinia'
  import ModalComponent from '@/features/interface/modal/ModalComponent.vue'
  import { useMachineEtatStore } from './useMachineEtatStore'
  import { useHideOnNavigate } from '../composables'

  const store = useMachineEtatStore()
  const { runOptions } = storeToRefs(store)
  const modalVisible = defineModel<boolean>({
    get: () => store.visible,
    set: (value) => {
      if (!value) {
        store.setCancel()
      }
    },
  })
  useHideOnNavigate(modalVisible)

  const out = ref<any>()
  const outReady = ref<boolean>(false)
  const transitionState = ref<MachineEtatTransitionState>()

  const onOutChanged = (ready: boolean, value: any, state: any) => {
    // console.log('onOutChanged', ready, value)
    outReady.value = ready
    out.value = value
    transitionState.value = {
      out: value,
      component: state,
    }
  }
  type MachineEtatTransitionState = {
    out: any
    component: any
  }

  watch(runOptions, () => {
    // console.log('watch', JSON.parse(JSON.stringify(runOptions.value)))
    if (runOptions.value?.transitionState) {
      const toRestoreState = runOptions.value.transitionState as MachineEtatTransitionState
      transitionState.value = toRestoreState
      out.value = toRestoreState.out
      outReady.value = true
    } else {
      transitionState.value = undefined
      out.value = undefined
      outReady.value = false
    }
  })

  const onGoBack = () => store.setGoBack()
  const onContinue = () => {
    if (outReady.value) {
      store.setResult(out.value, transitionState.value)
    }
  }
  const onCancel = () => {
    store.setCancel()
  }
</script>
